/**
 * Vintage-cursor decorations shared by the three mars-live time-series charts
 * (Expected Returns, Volatility, Portfolio Exposures).
 *
 * Each chart draws a dashed vertical line at the selected vintage date, with a
 * small white-boxed date label sitting just above the plot area.
 */
import type { Annotations, Shape } from 'plotly.js';

/** Dashed vertical line marking the selected vintage, or null if no vintage. */
export function vintageCursorShape(vintageDate: string): Partial<Shape> | null {
  if (!vintageDate) return null;
  return {
    type: 'line',
    xref: 'x',
    yref: 'paper',
    x0: vintageDate,
    x1: vintageDate,
    y0: 0,
    y1: 1,
    line: { color: 'rgba(29, 58, 71, 0.55)', width: 1.5, dash: 'dash' },
  };
}

/** White-boxed date label above the cursor line, or null if no vintage. */
export function vintageCursorAnnotation(vintageDate: string): Partial<Annotations> | null {
  if (!vintageDate) return null;
  return {
    xref: 'x',
    yref: 'paper',
    x: vintageDate,
    y: 1.0,
    yanchor: 'bottom',
    text: vintageDate,
    showarrow: false,
    font: { size: 11, color: '#1D3A47', family: 'Gill Sans MT' },
    xanchor: 'center',
    bgcolor: 'rgba(255,255,255,0.85)',
    bordercolor: 'rgba(29,58,71,0.2)',
    borderpad: 2,
    borderwidth: 1,
  };
}
